module.exports = __webpack_public_path__ + "static/media/mosque.8350356c.svg";